import getYear from "date-fns/getYear";

import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";

interface IMandatoryMinimumDividendTabContentProps {
  securities: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["securities"]>;
  mandatoryMinimumDividend: IBrazilianCompanyIssuerTopLevelFragment["mandatoryMinimumDividend"];
}

export default function MandatoryMinimumDividendTabContent({
  securities,
  mandatoryMinimumDividend,
}: IMandatoryMinimumDividendTabContentProps) {
  const hasNonOrdinarySecurities = securities.some(({ tickerSymbol }) => !tickerSymbol.endsWith("3"));

  if (!mandatoryMinimumDividend) {
    return null;
  }

  return (
    <div className="py-3">
      <dl className="m-0 overflow-hidden rounded">
        <div className="grid grid-cols-2 px-6 py-5 odd:bg-slate-100">
          <dt className="text-sm font-medium tracking-wider text-neutral-700">Dividendo Mínimo Obrigatório</dt>
          <dd className="text-sm font-medium tracking-wider text-neutral-900">
            <span>{mandatoryMinimumDividend.minimumDividend}</span>
          </dd>
        </div>

        <div className="grid grid-cols-2 px-6 py-5 odd:bg-slate-100">
          <dt className="text-sm font-medium tracking-wider text-neutral-700">Frequência</dt>
          <dd className="text-sm font-medium tracking-wider text-neutral-900">
            <span>{mandatoryMinimumDividend.frequency}</span>
          </dd>
        </div>

        {hasNonOrdinarySecurities && (
          <div className="grid grid-cols-2 px-6 py-5 odd:bg-slate-100">
            <dt className="text-sm font-medium tracking-wider text-neutral-700">ON vs PN</dt>
            <dd className="text-sm font-medium tracking-wider text-neutral-900">
              <span>{mandatoryMinimumDividend.commonPreferredDiscrepancy || "Sem informações"}</span>
            </dd>
          </div>
        )}
      </dl>

      <div className="mt-4">
        <span className="text-sm font-medium tracking-wider text-slate-500">
          {"Ano de Referência: "}
          <strong>{getYear(parseDateYmd(mandatoryMinimumDividend.reportDate))}</strong>
        </span>
      </div>
    </div>
  );
}
